import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInsuranceProgramsState, IListProgram } from './types/InsurancePrograms-interface';
import { fetchProgramsList } from './actions/fetch-programs-list';


const initialState: IInsuranceProgramsState = {
    listProgram: [],
    ProgramCount: 0,
    isLoadingListProgram: false,
    errorListProgram: [],
    lastFetchTime: null,
    contractsID: [],
    currentPage: 1,
    currentPageInCase: 1
};

export const insuranceProgramsList = createSlice({
    name: 'insuranceProgramsList',
    initialState,
    reducers: {
        resetListProgramsData: (state) => {
            state.listProgram = [];
            state.ProgramCount = 0;
            state.isLoadingListProgram = false;
            state.errorListProgram = [];
            state.lastFetchTime = null;
            state.contractsID = [];
            state.currentPage = 1;
            state.currentPageInCase = 1;
        },
        setCurrentPage: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPage = action.payload.page;
        },
        setCurrentPageInCase: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPageInCase = action.payload.page;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProgramsList.pending, (state) => {
                state.isLoadingListProgram = true;
            })
            .addCase(fetchProgramsList.fulfilled, (state, action: PayloadAction<{ list: IListProgram[], programCount: number, fetchTime: number, contractID: string[] | [] }>) => {
                state.isLoadingListProgram = false;
                state.listProgram = action.payload.list;
                state.ProgramCount = action.payload.programCount;
                state.errorListProgram = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.contractsID = action.payload.contractID;
                state.currentPage = state.currentPage;
                state.currentPageInCase = state.currentPageInCase;
            })
            .addCase(fetchProgramsList.rejected, (state, action) => {
                state.listProgram = [];
                state.isLoadingListProgram = false;
                state.errorListProgram = action.payload as string[];
                state.contractsID = [];
                state.currentPage = 1;
                state.currentPageInCase = 1;
            });
    },
});

export const { resetListProgramsData, setCurrentPage, setCurrentPageInCase } = insuranceProgramsList.actions;
export default insuranceProgramsList.reducer;
